import React, { useEffect, useState } from 'react';

import { FormComponent, ModalComponent, UiComponent } from 'components';
import { useFileService } from 'hooks';
import { IEvent, IOpenTalk } from 'types';
import useModal from 'hooks/useModal';
import { FileServiceQuery, OpenTalkQuery } from 'queries';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';

interface Props {
  event?: IEvent | null;
  onClose: () => void;
}

function OpenKakao({ event, onClose }: Props) {
  const { handleAlert } = useModal();
  const { data, isLoading } = OpenTalkQuery.useGet(
    String(event?.openTalkId || ''),
  );

  const { fileUrl, file, handleFile, setFileUrl } = useFileService({
    initFileUrl: '',
  });
  const [code, setCode] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  const { handleUploadd: upload } = FileServiceQuery.useUpload();
  const { mutate: create } = OpenTalkQuery.useCreate();
  const { mutate: update } = OpenTalkQuery.useUpdate();

  const handleSubmit = async () => {
    if (isLoading) return;
    if (!event) return;

    if (!fileUrl) {
      handleAlert('썸네일을 업로드해주세요');
      return;
    }

    let thumbnail = fileUrl;
    let isNewFile = false;
    if (file) {
      const res = await upload(file);
      if (!res) return;
      thumbnail = res.data.url;
      isNewFile = true;
    }

    const dto = {
      code,
      title,
      description,
      thumbnail,
    };

    if (data?.id) {
      update(
        { ...dto, id: data.id, isNewFile },
        {
          onSuccess: () => {
            toast.success('오픈채팅방 링크가 저장되었습니다.');
            onClose();
          },
          onError: () => {
            toast.error(DEFAULT_ERROR_MESSAGE);
          },
        },
      );
      return;
    }

    create(
      { ...dto, eventId: event.id },
      {
        onSuccess: () => {
          toast.success('카카오톡 채널이 저장되었습니다.');
          onClose();
        },
        onError: () => {
          toast.error(DEFAULT_ERROR_MESSAGE);
        },
      },
    );
  };

  const init = () => {
    if (!data) return;

    const { code, description, title, thumbnail } = data as IOpenTalk;
    setCode(code);
    setDescription(description);
    setTitle(title);
    setFileUrl(thumbnail);
  };

  useEffect(() => init(), [data]);

  return (
    <ModalComponent.Portal>
      <ModalComponent.Background>
        <ModalComponent.Modal title="" handleClose={onClose} footer={<></>}>
          <FormComponent.Form
            css={{
              display: 'flex',
              flexDirection: 'column',
              width: '500px',
              gap: '12px 0',
            }}
            submit={handleSubmit}
          >
            <p>썸네일</p>
            <UiComponent.FileUpload
              name="thumbnail"
              fileUrl={fileUrl}
              handleFile={handleFile}
            />
            <p>Code</p>
            <FormComponent.Input
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
            <p>제목</p>
            <FormComponent.Input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <p>상세</p>
            <FormComponent.Input
              name="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />

            <UiComponent.Button
              type="submit"
              color="primary"
              variant="contained"
              css={{ width: '120px', margin: '0 auto' }}
            >
              저장
            </UiComponent.Button>
          </FormComponent.Form>
        </ModalComponent.Modal>
      </ModalComponent.Background>
    </ModalComponent.Portal>
  );
}

export default OpenKakao;
